"use client";

import { Thread } from "@assistant-ui/react";
import { useEffect, useState } from "react";
import { makeMarkdownText } from "@assistant-ui/react-markdown";
import { DisplayDataTool } from "@/components/tools/DisplayDataTool";
import { useRuntime } from "@/app/MyRuntimeProvider"; 
import { useParams } from "next/navigation";
import { Spin } from "antd";

const MarkdownText = makeMarkdownText();

const getOrCreateUserId = async () => {
  let userId = localStorage.getItem("coverboy_user_id");
  if (!userId) {
    // Generate unique identifier if it doesn't already exist
    userId = crypto.randomUUID();
    localStorage.setItem("coverboy_user_id", userId);
  }

  const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
  // Send user info to backend
  try {
    await fetch(`${baseUrl}/track_user`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: userId }),
    });
  } catch (error) {
    console.error("Error tracking user:", error);
  }
};

export default function SharePage() {
  const { resetMessages } = useRuntime() || {};
  const params = useParams();
  const shareToken = params?.share_token;
  
  const [loading, setLoading] = useState(true); // Track loading state

  useEffect(() => {
    if (!resetMessages || !shareToken) return;

    if (typeof window !== 'undefined') {
      // You can use localStorage here
      getOrCreateUserId();
    }

    async function fetchSharedMessages() {
      const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

      try {
        const response = await fetch(`${apiBaseUrl}/api/share/${shareToken}`, {
          credentials: "include",
        });
        if (!response.ok) throw new Error("Failed to load conversation");
        
        const data = await response.json();
        if (resetMessages) {
            resetMessages(data.messages);
        }
      } catch (err) {
        console.error(`Share link not found or expired. See the following error: ${err}`);
      } finally {
        setLoading(false); // Stop loading after fetch completes
      }
    }

    fetchSharedMessages();
  }, [resetMessages, shareToken]);

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="flex h-full flex-col">
      <Thread
        assistantMessage={{ components: { Text: MarkdownText } }}
        tools={[DisplayDataTool]}
      />
    </div>
  );
}
